export default "/template/resource//static/media/img_bg_center_login@2x.ff031df6.png";